import styled from "styled-components";

export const Page = styled.div`
  
`;

const DMTableWrapper = styled.div`
`;

export default DMTableWrapper;